import { Paragraph, ParagraphType, ParagraphDataType } from "@/model";
import * as ParagraphData from "@/model/paragraph";


const createTypeGuard = <T extends Paragraph>(type: ParagraphType, dataType: ParagraphDataType) => {
    return (p: Paragraph): p is T => p.type === type && p.data_type === dataType;
};
export const isNext = createTypeGuard<ParagraphData.ParagraphNext>("next", "next");
export const isTemplate = createTypeGuard<ParagraphData.ParagraphTemplate>("template", "template");
export const isVariable = createTypeGuard<ParagraphData.ParagraphUtilityVariable>("utility", "variable");
export const isApi = createTypeGuard<ParagraphData.ParagraphUtilityApi>("utility", "api");
export const isCode = createTypeGuard<ParagraphData.ParagraphUtilityCode>("utility", "code");
export const isCustom = createTypeGuard<ParagraphData.ParagraphOutputCustom>("output", "custom");
export const isMedia = createTypeGuard<ParagraphData.ParagraphOutputMedia>("output", "media");
export const isFile = createTypeGuard<ParagraphData.ParagraphOutputFile>("output", "file");
export const isLLMAnswer = createTypeGuard<ParagraphData.ParagraphOutputLLMAnswer>("output", "llm_answer");
export const isTextOutput = createTypeGuard<ParagraphData.ParagraphOutputText>("output", "text");
export const isCarousel = createTypeGuard<ParagraphData.ParagraphOutputCarousel>("output", "carousel");
export const isRaw = createTypeGuard<ParagraphData.ParagraphOutputRaw>("output", "raw");
export const isList = createTypeGuard<ParagraphData.ParagraphInputList>("input", "list");
export const isQuickReply = createTypeGuard<ParagraphData.ParagraphInputQuickReply>("input", "quick_reply");
export const isTextInput = createTypeGuard<ParagraphData.ParagraphInputText>("input", "text");

export const isNextConditionData = (data: any): data is ParagraphData.NextConditionData => {
    return 'condition' in data;
};
export const isParagraphButtonData = (data: any): data is ParagraphData.ParagraphButtonData => {
    return 'label' in data;
};

export const filterNextConditionData = (
    data: (ParagraphData.NextConditionData | ParagraphData.ParagraphButtonData)[]
): ParagraphData.NextConditionData[] => {
    return data.filter(isNextConditionData) as ParagraphData.NextConditionData[];
};
export const filterParagraphButtonData = (
    data: (ParagraphData.NextConditionData | ParagraphData.ParagraphButtonData)[]
): ParagraphData.ParagraphButtonData[] => {
    return data.filter(isParagraphButtonData) as ParagraphData.ParagraphButtonData[];
};
